import { Component, OnInit } from '@angular/core';
import { Licitacao } from '../../_classes/licitacao';
import { Arquivo } from '../../_classes/arquivo';
import { LicitacaoFilter } from '../../_classes/licitacaoFilter';
import { Router, ActivatedRoute } from '@angular/router';

import { MODALIDADES } from '../../_mocks/modalidades';
import { COMISSOES } from '../../_mocks/comissoes';
import { ORGAOS } from '../../_mocks/orgaos';
import { TIPO_DE_DOCUMENTOS } from '../../_mocks/tipoDeDocumentos';
import { FASES_DA_LICITACAO } from '../../_mocks/fasesDaLicitacao';
import { TIPOS_DE_OBJETO_DA_LICITACAO } from '../../_mocks/tiposDeObjetoDaLicitacao';
import { Base64Service } from '../../services/base64.service';

import { saveAs } from 'file-saver/FileSaver';
import { LoadingService } from '../../services/loading.service';
import { LicitacaoService } from '../../services/licitacao.service';

import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { UserSessionService } from '../../services/user-session.service';
import { URL } from '../../_mocks/url';
import { DadosPaginacao } from '../paginacao/dadosPaginacao';
import { BehaviorSubject } from 'rxjs';
import { ConfiguracaoPaginacao } from '../paginacao/configuracaoPaginacao';

@Component({
  selector: 'app-licitacao-list-simple',
  templateUrl: './licitacao-list-simple.component.html',
  styleUrls: ['./licitacao-list-simple.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS }
  ]
})
export class LicitacaoListSimpleComponent implements OnInit {

  isUserSession: boolean;
  filter = '';
  order = '';
  orderDataSaved = false;
  public maskLicitacao = [/\d/, /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public maskData = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public mascaraCnpj = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/,];
  licitacoes: Licitacao[];
  arquivos: Arquivo[];
  modalidades = MODALIDADES;
  comissoes = COMISSOES;
  orgaos = ORGAOS;
  tipoDeDocumentos = TIPO_DE_DOCUMENTOS;
  fasesDaLicitacao = FASES_DA_LICITACAO;
  tiposDeObjetoDaLicitacao = TIPOS_DE_OBJETO_DA_LICITACAO;
  licitacaoFilter = new LicitacaoFilter();

  /**
   * Paginacao
   */
  ultimoDadoPaginacao: DadosPaginacao;
  subjectPaginacao: BehaviorSubject<ConfiguracaoPaginacao> = new BehaviorSubject<ConfiguracaoPaginacao>(undefined);

  constructor(
    private adapter: DateAdapter<any>,
    private licitacaoService: LicitacaoService,
    private base64Service: Base64Service,
    private loadingService: LoadingService,
    private userSession: UserSessionService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.getLicitacoesByFilter(false);
    this.getUserSession();
    this.listenToQueryParams();
  }

  getLicitacoes() {
    this.licitacaoService.getLicitacoes().subscribe(licitacoes => {
      this.licitacoes = licitacoes;
      this.formatarCNPJNumeroContrato();
    });
  }

  /**
   * Metodo de onde query params devem ser buscados
   */
  listenToQueryParams() {
    this.route.queryParams.subscribe(params => {
      this.changeCovid19Status(params['covid19']);
    });
  }

   /**
   * Altera o atributo de filtragem do covid19 e realiza a consulta
   * dos resultados
   */
  changeCovid19Status(status) {
    this.licitacaoFilter.isCovid19 = status === 'true' ? true : false;
    this.getLicitacoesByFilter(false);
  }

  formatarCNPJNumeroContrato() {
    this.licitacoes.forEach(licitacao => {
      licitacao.cnpj = licitacao.cnpj.toString().replace(/\,/g, ', ')
      licitacao.numeroContrato = licitacao.numeroContrato.toString().replace(/\,/g, ', ')
    })
  }

  getUserSession() {
    this.userSession.isUserSession.subscribe(user => {
      this.isUserSession = user;
    });
  }

  loadFiles(id: number) {
    this.arquivos = [];
    this.loadingService.changeLoading(true);
    this.licitacaoService.getArquivosDaLicitacao(id).subscribe(arquivos => {
      this.loadingService.changeLoading(false);
      this.arquivos = arquivos;
    });
  }

  getLicitacoesByFilter(isPaginationEvent: boolean) {
    this.orderDataSaved = true;
    this.loadingService.changeLoading(true);
    this.licitacaoService.getLicitacoesByFilter(this.licitacaoFilter, this.ultimoDadoPaginacao)
      .subscribe(result => {
        this.licitacoes = result;
        this.order = 'dataDeRealizacao';
        this.loadingService.changeLoading(false);
      }, error => {
        this.loadingService.changeLoading(false);
      });

    if (!isPaginationEvent) {
      this.licitacaoService.getTotalEntidades(this.licitacaoFilter).subscribe((total) => {
        const configuracaoPaginacao = new ConfiguracaoPaginacao();
        configuracaoPaginacao.totalPaginas = total;
        configuracaoPaginacao.paginaAtual = 0;

        this.subjectPaginacao.next(configuracaoPaginacao);
      });
    }
  }

  download(arquivo: Arquivo) {
    this.loadingService.changeLoading(true);
    // window.open(URL + `arquivo/download/${arquivo.id}/${arquivo.nome}`);
    window.open(arquivo.valor);
    // tslint:disable-next-line:max-line-length
    // alert('Arquivo já está sendo baixado. Pode continuar normalmente utilizando o sistema. Quando o download terminar você será notificado!');
    // this.licitacaoService.getValorDoArquivoPorId(arquivo.id).subscribe(value => {
    // }, value => {
    //  this.base64Service.convertToBlobPDF(value.error.text, function (result) {
    //    saveAs(result, arquivo.nome);
    //    alert('Arquivo baixado.');
    //    this.loadingService.changeLoading(false);
    //  });
    // });
  }

  goToEditLicitacao(idLicitacao: number) {
    this.router.navigate([`/dashboard/licitacao/edit/${idLicitacao}`]);
  }

  private generateLink(arquivo: Arquivo) {
    const dataURI = 'data:' + 'application/octet-stream;charset=utf8' +
      ';base64,' + arquivo.valor;
    return dataURI;
  }

  private searchRefer(list: any[], name) {
    let label = '';
    list.forEach(v => {
      if (v.value === name) {
        label = v.label;
      }
    });
    return label;
  }

  private sortByNumeroLicitacao(a, b) {
    if (a > b) {
      return 1;
    }
    if (b > a) {
      return -1;
    }

    return 0;
  }

  onPaginationChange(eventoPaginacao: DadosPaginacao) {
    this.ultimoDadoPaginacao = eventoPaginacao;
    this.getLicitacoesByFilter(true);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/licitacao-list-simple/licitacao-list-simple.component.ts